module.exports = __webpack_public_path__ + "assets/img/used-icon.2fd2eb39.png";